<template>
  <AppCarousel
    :breakpoints="{
      851: { itemsToShow: 2.3 },
      1000: { itemsToShow: 2.6 },
      1250: { itemsToShow: 3.1 },
      1550: { itemsToShow: 3.7 },
      2000: { itemsToShow: 4 },
    }"
    :gap="0"
    height="auto"
    snap-align="start"
    wrap-around navigation end elevated
  >
    <AppCarouselSlide v-for="(item) in groupedTestimonials">
      <div v-if="Array.isArray(item)" class="flex col self-start gap-6">
        <TestimonialCard
          v-for="(testimonial, subIndex) in item"
          :key="subIndex"
          :testimonial="testimonial"
        />
      </div>
      <TestimonialCard v-else :testimonial="item" />
    </AppCarouselSlide>
  </AppCarousel>
</template>

<script setup lang="ts">
import type { Testimonial } from '~/types';
import { AppCarousel } from '#components';

const props = defineProps<{
  testimonials: Testimonial[];
}>();

const groupedTestimonials = computed(() => {
  const grouped: (Testimonial | Testimonial[])[] = [];
  let index = 0;

  while (index < props.testimonials.length) {
    const currentTestimonial = props.testimonials[index];
    const nextTestimonial = props.testimonials[index + 1];

    if (currentTestimonial.stacked && nextTestimonial) {
      grouped.push([currentTestimonial, nextTestimonial]);
      index += 2;
    } else {
      grouped.push(currentTestimonial);
      index++;
    }
  }

  return grouped;
});
</script>